export const roles = {
  HR: {
    id: "HR",
    label: "HR",
    lane: "HR",
    description: "Manages hiring workflow for PAM onboarding.",
    route: "/hr",
    apiEndpoint: "/api/workflow/hr/intake",
    color: "#0ea5e9",
  },
  PAM: {
    id: "PAM",
    label: "PAM",
    lane: "PAM",
    description: "Runs field work, property discovery, and site visit execution.",
    route: "/pam-dashboard",
    apiEndpoint: "/api/workflow/pam/tasks",
    color: "#2563eb",
  },
  HPAM: {
    id: "HPAM",
    label: "HPAM",
    lane: "HPAM",
    description: "Validates PAM submissions and routes approval or rework.",
    route: "/hpam",
    apiEndpoint: "/api/workflow/hpam/validation",
    color: "#4f46e5",
  },
  Admin: {
    id: "Admin",
    label: "Admin",
    lane: "Admin",
    description: "Performs governance review and CRM handoff readiness.",
    route: "/admin",
    apiEndpoint: "/api/workflow/admin/review",
    color: "#7c3aed",
  },
  CRM: {
    id: "CRM",
    label: "CRM",
    lane: "CRM",
    description: "Stores and manages property records and presentation trigger.",
    route: "/crm",
    apiEndpoint: "/api/workflow/crm/process",
    color: "#0891b2",
  },
  CRE: {
    id: "CRE",
    label: "CRO CRE",
    lane: "CRO CRE",
    description: "Creates and shares presentations with business teams.",
    route: "/cre",
    apiEndpoint: "/api/workflow/cre/presentation",
    color: "#0d9488",
  },
  LH: {
    id: "LH",
    label: "Leasing Head",
    lane: "Leasing Head",
    description: "Leads brand outreach and option sharing.",
    route: "/leasing-head",
    apiEndpoint: "/api/workflow/leasing/head",
    color: "#ca8a04",
  },
  BDM: {
    id: "BDM",
    label: "BDM",
    lane: "BDM",
    description: "Handles partner communication and business qualification.",
    route: "/bdm",
    apiEndpoint: "/api/workflow/bdm/outreach",
    color: "#d97706",
  },
  Brand: {
    id: "Brand",
    label: "Brand",
    lane: "Brand",
    description: "Reviews options and makes property selection decisions.",
    route: "/brand",
    apiEndpoint: "/api/workflow/brand/approval",
    color: "#ea580c",
  },
  OM: {
    id: "OM",
    label: "Operations Manager",
    lane: "Operations Manager",
    description: "Schedules site visits and assigns PAM for execution.",
    route: "/operations-manager",
    apiEndpoint: "/api/workflow/om/visit",
    color: "#db2777",
  },
  Legal: {
    id: "Legal",
    label: "Legal Team",
    lane: "Legal Team",
    description: "Manages LOI drafting and final agreement closure.",
    route: "/legal",
    apiEndpoint: "/api/workflow/legal/finalize",
    color: "#be185d",
  },
  Finance: {
    id: "Finance",
    label: "Finance Team",
    lane: "Finance Team",
    description: "Runs invoicing, follow up, and payment confirmation.",
    route: "/finance",
    apiEndpoint: "/api/workflow/finance/approval",
    color: "#9333ea",
  },
  Technical: {
    id: "Technical",
    label: "Technical Manager",
    lane: "Technical Manager",
    description: "Prepares property setup and executes store launch.",
    route: "/technical",
    apiEndpoint: "/api/workflow/technical/execute",
    color: "#16a34a",
  },
};

export const roleOrder = [
  "HR",
  "PAM",
  "HPAM",
  "Admin",
  "CRM",
  "CRE",
  "LH",
  "BDM",
  "Brand",
  "OM",
  "Legal",
  "Finance",
  "Technical",
];

export const workflowNodes = [
  { id: "HR_JOB_CREATE", roleId: "HR", label: "Create Job Opening" },
  { id: "HR_JOB_MANAGE", roleId: "HR", label: "Manage Job Openings" },
  { id: "HR_HIRE", roleId: "HR", label: "Hiring" },
  { id: "HR_EMP_CREATE", roleId: "HR", label: "Create Employee" },
  { id: "HR_EMP_MANAGE", roleId: "HR", label: "Manage Employees" },
  { id: "HR_DOC_UPLOAD", roleId: "HR", label: "Upload Documents" },
  { id: "HR_ATTENDANCE", roleId: "HR", label: "Attendance Management" },
  { id: "HR_ATT_OFFICE", roleId: "HR", label: "Office Attendance Punch Machine" },
  { id: "HR_ATT_FIELD", roleId: "HR", label: "Field Attendance Mobile Selfie GPS" },
  { id: "HR_LEAVE", roleId: "HR", label: "Leave Management" },
  { id: "HR_PAYROLL", roleId: "HR", label: "Payroll Generation" },

  { id: "PAM_TASK_CREATE", roleId: "PAM", label: "Create Daily Task" },
  { id: "PAM_TASK_SUBMIT", roleId: "PAM", label: "Submit Task to HPAM" },

  { id: "PAM_LOGIN", roleId: "PAM", label: "Login" },
  { id: "PAM_ATT", roleId: "PAM", label: "Selfie Attendance" },
  { id: "PAM_AREA", roleId: "PAM", label: "Area selection" },
  { id: "PAM_MAP", roleId: "PAM", label: "Street mapping" },
  { id: "PAM_SURVEY", roleId: "PAM", label: "Survey" },
  { id: "PAM_IDENTIFY", roleId: "PAM", label: "Property identification" },
  { id: "PAM_DEV", roleId: "PAM", label: "Developer connection" },
  { id: "PAM_UPLOAD", roleId: "PAM", label: "Data upload" },
  { id: "PAM_REPORT", roleId: "PAM", label: "Report submission" },
  { id: "PAM_VISIT", roleId: "PAM", label: "Conduct site visit" },

  { id: "HPAM_REVIEW", roleId: "HPAM", label: "Review data" },
  { id: "HPAM_TASK_REVIEW", roleId: "HPAM", label: "Review Daily Task" },
  { id: "HPAM_TASK_DECISION", roleId: "HPAM", label: "Task Approved" },
  { id: "HPAM_VALID", roleId: "HPAM", label: "Data valid" },

  { id: "AD_REVIEW", roleId: "Admin", label: "Review" },
  { id: "AD_MODIFY", roleId: "Admin", label: "Modify" },
  { id: "AD_DECIDE", roleId: "Admin", label: "Modify required" },
  { id: "AD_PUSH", roleId: "Admin", label: "Approve and push CRM" },

  { id: "CRM_STORE", roleId: "CRM", label: "Store inventory" },
  { id: "CRM_MANAGE", roleId: "CRM", label: "Manage data" },
  { id: "CRM_TRIGGER", roleId: "CRM", label: "Trigger presentation" },
  { id: "CRM_MATCH", roleId: "CRM", label: "Match Properties" },

  { id: "CRE_PPT", roleId: "CRE", label: "Create PPT" },
  { id: "CRE_UPLOAD", roleId: "CRE", label: "Upload presentation" },
  { id: "CRE_SHARE", roleId: "CRE", label: "Send to LH and BDM" },

  { id: "LH_CONNECT", roleId: "LH", label: "Connect with brands" },
  { id: "LH_SHARE", roleId: "LH", label: "Share property options" },

  { id: "BDM_CONNECT", roleId: "BDM", label: "Connect with brands" },
  { id: "BDM_SHARE", roleId: "BDM", label: "Share property options" },
  { id: "BDM_INTEREST", roleId: "BDM", label: "Interested" },
  { id: "BDM_DROP", roleId: "BDM", label: "Drop lead" },

  { id: "BRAND_REVIEW", roleId: "Brand", label: "Review Options" },
  { id: "BRAND_REQUIREMENT", roleId: "Brand", label: "Brand Requirement" },
  { id: "BRAND_MANDATE", roleId: "Brand", label: "Create Mandate" },
  { id: "BRAND_SHORT", roleId: "Brand", label: "Shortlist" },
  { id: "BRAND_VISIT", roleId: "Brand", label: "Request visit" },
  { id: "BRAND_SELECT", roleId: "Brand", label: "Property selected" },
  { id: "BRAND_CONFIRM", roleId: "Brand", label: "Confirm property" },

  { id: "OM_SCHEDULE", roleId: "OM", label: "Schedule visit" },
  { id: "OM_ASSIGN", roleId: "OM", label: "Assign PAM" },

  { id: "LEGAL_LOI", roleId: "Legal", label: "Draft LOI" },
  { id: "LEGAL_NEG", roleId: "Legal", label: "Negotiate terms" },
  { id: "LEGAL_AGREEMENT", roleId: "Legal", label: "Create agreement" },
  { id: "LEGAL_FINAL", roleId: "Legal", label: "Finalize documents" },

  { id: "FIN_INVOICE", roleId: "Finance", label: "Generate invoice" },
  { id: "FIN_SEND", roleId: "Finance", label: "Send invoice" },
  { id: "FIN_PAID", roleId: "Finance", label: "Payment done" },
  { id: "FIN_FOLLOW", roleId: "Finance", label: "Follow up" },
  { id: "FIN_CONFIRM", roleId: "Finance", label: "Confirm payment" },

  { id: "TECH_SETUP", roleId: "Technical", label: "Setup" },
  { id: "TECH_INFRA", roleId: "Technical", label: "Infrastructure setup" },
  { id: "TECH_CHECK", roleId: "Technical", label: "Final inspection" },
  { id: "TECH_LAUNCH", roleId: "Technical", label: "Launch store" },
];

export const nodeRoutes = {
  PAM: "/pam-dashboard",
  CRM: "/crm",
  Legal: "/legal",
  HR: "/hr",
  HPAM: "/hpam",
  Admin: "/admin",
  CRE: "/cre",
  LH: "/leasing-head",
  BDM: "/bdm",
  Brand: "/brand",
  OM: "/operations-manager",
  Finance: "/finance",
  Technical: "/technical",
};

export const edges = [
  { from: "HR_JOB_CREATE", to: "HR_JOB_MANAGE", label: "HR", group: "pam" },
  { from: "HR_JOB_MANAGE", to: "HR_HIRE", label: "Hiring", group: "pam" },
  { from: "HR_HIRE", to: "HR_EMP_CREATE", label: "Employee", group: "pam" },
  { from: "HR_EMP_CREATE", to: "HR_EMP_MANAGE", label: "Employee", group: "pam" },
  { from: "HR_EMP_MANAGE", to: "HR_DOC_UPLOAD", label: "Employee", group: "pam" },
  { from: "HR_DOC_UPLOAD", to: "HR_ATTENDANCE", label: "HR", group: "pam" },
  { from: "HR_ATTENDANCE", to: "HR_ATT_OFFICE", label: "Office", group: "pam" },
  { from: "HR_ATTENDANCE", to: "HR_ATT_FIELD", label: "Field", group: "pam" },
  { from: "HR_ATT_OFFICE", to: "HR_LEAVE", label: "HR", group: "pam" },
  { from: "HR_ATT_FIELD", to: "HR_LEAVE", label: "HR", group: "pam" },
  { from: "HR_LEAVE", to: "HR_PAYROLL", label: "HR", group: "pam" },
  { from: "HR_PAYROLL", to: "PAM_LOGIN", label: "Onboard", group: "pam" },

  { from: "PAM_LOGIN", to: "PAM_ATT", label: "Daily start", group: "pam" },
  { from: "PAM_ATT", to: "PAM_TASK_CREATE", label: "Task planning", group: "pam" },
  { from: "PAM_TASK_CREATE", to: "PAM_TASK_SUBMIT", label: "Submit", group: "pam" },
  { from: "PAM_TASK_SUBMIT", to: "HPAM_TASK_REVIEW", label: "HPAM", group: "pam" },
  { from: "HPAM_TASK_REVIEW", to: "HPAM_TASK_DECISION", label: "Decision", group: "pam" },
  { from: "HPAM_TASK_DECISION", to: "PAM_TASK_CREATE", label: "No", group: "pam" },
  { from: "HPAM_TASK_DECISION", to: "PAM_AREA", label: "Yes", group: "pam" },

  { from: "PAM_AREA", to: "PAM_MAP", label: "Field work", group: "pam" },
  { from: "PAM_MAP", to: "PAM_SURVEY", label: "Field work", group: "pam" },
  { from: "PAM_SURVEY", to: "PAM_IDENTIFY", label: "Field work", group: "pam" },
  { from: "PAM_IDENTIFY", to: "PAM_DEV", label: "Field work", group: "pam" },
  { from: "PAM_DEV", to: "PAM_UPLOAD", label: "Field work", group: "pam" },
  { from: "PAM_UPLOAD", to: "PAM_REPORT", label: "Field work", group: "pam" },
  { from: "PAM_REPORT", to: "HPAM_REVIEW", label: "Submit", group: "pam" },

  { from: "HPAM_REVIEW", to: "HPAM_VALID", label: "Validation", group: "pam" },
  { from: "HPAM_VALID", to: "PAM_AREA", label: "Invalid", group: "pam" },
  { from: "HPAM_VALID", to: "AD_REVIEW", label: "Valid", group: "crm" },

  { from: "AD_REVIEW", to: "AD_DECIDE", label: "Admin", group: "crm" },
  { from: "AD_DECIDE", to: "AD_MODIFY", label: "Yes", group: "crm" },
  { from: "AD_MODIFY", to: "AD_REVIEW", label: "Recheck", group: "crm" },
  { from: "AD_DECIDE", to: "AD_PUSH", label: "No", group: "crm" },
  { from: "AD_PUSH", to: "CRM_STORE", label: "CRM handoff", group: "crm" },

  { from: "CRM_STORE", to: "CRM_MANAGE", label: "CRM", group: "crm" },
  { from: "CRM_MANAGE", to: "CRM_TRIGGER", label: "CRM", group: "crm" },
  { from: "CRM_TRIGGER", to: "CRE_PPT", label: "Presentation", group: "crm" },

  { from: "CRE_PPT", to: "CRE_UPLOAD", label: "Presentation", group: "crm" },
  { from: "CRE_UPLOAD", to: "CRE_SHARE", label: "Presentation", group: "crm" },
  { from: "CRE_SHARE", to: "LH_CONNECT", label: "Business", group: "business" },
  { from: "CRE_SHARE", to: "BDM_CONNECT", label: "Business", group: "business" },

  { from: "LH_CONNECT", to: "BRAND_REQUIREMENT", label: "Business", group: "business" },
  { from: "BDM_CONNECT", to: "BRAND_REQUIREMENT", label: "Business", group: "business" },
  { from: "BRAND_REQUIREMENT", to: "BRAND_MANDATE", label: "Mandate", group: "business" },
  { from: "BRAND_MANDATE", to: "CRM_MATCH", label: "CRM", group: "business" },
  { from: "CRM_MATCH", to: "BRAND_REVIEW", label: "Match", group: "business" },
  { from: "BRAND_REVIEW", to: "BRAND_SHORT", label: "Shortlist", group: "visit" },
  { from: "BRAND_SHORT", to: "BRAND_VISIT", label: "Brand", group: "visit" },
  { from: "BRAND_VISIT", to: "OM_SCHEDULE", label: "Visit", group: "visit" },

  { from: "OM_SCHEDULE", to: "OM_ASSIGN", label: "Visit", group: "visit" },
  { from: "OM_ASSIGN", to: "PAM_VISIT", label: "Visit", group: "visit" },
  { from: "PAM_VISIT", to: "BRAND_SELECT", label: "Decision", group: "visit" },

  { from: "BRAND_SELECT", to: "LH_SHARE", label: "Rejected", group: "business" },
  { from: "BRAND_SELECT", to: "BRAND_CONFIRM", label: "Selected", group: "deal" },
  { from: "BRAND_CONFIRM", to: "LEGAL_LOI", label: "Legal", group: "deal" },

  { from: "LEGAL_LOI", to: "LEGAL_NEG", label: "Legal", group: "deal" },
  { from: "LEGAL_NEG", to: "LEGAL_AGREEMENT", label: "Legal", group: "deal" },
  { from: "LEGAL_AGREEMENT", to: "LEGAL_FINAL", label: "Legal", group: "deal" },
  { from: "LEGAL_FINAL", to: "FIN_INVOICE", label: "Finance", group: "deal" },

  { from: "FIN_INVOICE", to: "FIN_SEND", label: "Finance", group: "execution" },
  { from: "FIN_SEND", to: "FIN_PAID", label: "Payment", group: "execution" },
  { from: "FIN_PAID", to: "FIN_FOLLOW", label: "Not paid", group: "execution" },
  { from: "FIN_FOLLOW", to: "FIN_SEND", label: "Follow up", group: "execution" },
  { from: "FIN_PAID", to: "FIN_CONFIRM", label: "Paid", group: "execution" },

  { from: "FIN_CONFIRM", to: "TECH_SETUP", label: "Execution", group: "execution" },
  { from: "TECH_SETUP", to: "TECH_INFRA", label: "Execution", group: "execution" },
  { from: "TECH_INFRA", to: "TECH_CHECK", label: "Execution", group: "execution" },
  { from: "TECH_CHECK", to: "TECH_LAUNCH", label: "Launch", group: "execution" },
];

export const filterModes = {
  full: {
    id: "full",
    label: "Show Full Flow",
    groups: ["pam", "crm", "business", "visit", "deal", "execution"],
  },
  pam: {
    id: "pam",
    label: "Show Only PAM Flow",
    groups: ["pam", "visit"],
  },
  crm: {
    id: "crm",
    label: "Show Only CRM Flow",
    groups: ["crm", "business"],
  },
};
